import { render, staticRenderFns } from "./UnionFieldEdit.vue?vue&type=template&id=01938f1c&scoped=true&"
import script from "./UnionFieldEdit.vue?vue&type=script&lang=js&"
export * from "./UnionFieldEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01938f1c",
  null
  
)

export default component.exports